import { DraftConfigurationTextStyle, Size } from '@/types';
import { textAlignToAnchor } from '@/utils/text/textAlignToAnchor';
import { SVG_NS } from './consts';
import { getMeasurer } from './getMeasurer';

export const getTextSizeForStyle = (style: DraftConfigurationTextStyle, text: string): Size => {
  const svg = getMeasurer();
  const font = style.font;

  const textElement = document.createElementNS(SVG_NS, 'text');
  textElement.setAttribute('text-rendering', 'geometricPrecision');
  textElement.setAttribute('letter-spacing', '0px');
  svg.appendChild(textElement);

  const tspans = text.split('\n').map((line, lineIndex) => {
    const tspan = document.createElementNS(SVG_NS, 'tspan');

    tspan.setAttribute('font-size', String(style.fontSize));
    tspan.setAttribute('font-family', font.identifier);
    tspan.setAttribute('font-style', font.style);
    tspan.setAttribute('font-weight', font.weight);
    tspan.setAttribute('text-anchor', textAlignToAnchor(style.textAlign));
    tspan.setAttribute('style', 'white-space:pre');
    tspan.setAttribute('x', String(style.x));
    tspan.setAttribute('y', String(Number(style.y) + lineIndex * Number(style.fontSize) * 1.2));

    tspan.textContent = line;
    return tspan;
  });

  tspans.forEach((tspan) => {
    textElement.appendChild(tspan);
  });

  const box = textElement.getBBox();

  svg.removeChild(textElement);

  return {
    width: box.width + box.x,
    height: box.height + box.y,
    unit: 'mm',
  };
};
